// lib
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Switch, Redirect, Route, useHistory, useLocation } from "react-router-dom";
import { LinearProgress } from "@material-ui/core";
// src
import { createTicketRequestURL } from "services/cas";
import AppBar from "containers/partials/AppBar";
import DeepLink from "containers/plannings/routes/DeepLink";
import Home from "containers/plannings/routes/Home";
import LightHome from "containers/plannings/routes/LightHome";
import ExternalRedirect from "components/helpers/ExternalRedirect";
import Colors from "components/plannings/routes/admin/Colors";
import TicketCallback from "components/helpers/TicketCallback";
import LoggedGate from "components/helpers/LoggedGate";
import LoggedRoute from "components/helpers/LoggedRoute";
import Logout from "components/helpers/Logout";
import Modals from "components/modals/Modals";

const track = (path, idop) => {
  const _paq = (window._paq = window._paq || []);
  const u = "//matomo.centralesupelec.fr/";

  if (!_paq.length) {
    if (idop) {
      _paq.push(["setUserId", `${idop}`]);
    }

    /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
    _paq.push(["trackPageView"]);
    _paq.push(["enableLinkTracking"]);

    _paq.push(["setTrackerUrl", u + "matomo.php"]);
    _paq.push(["setSiteId", "5"]);
    _paq.push(["addTracker", u + "matomo.php", "4"]);

    const g = document.createElement("script");
    const s = document.getElementsByTagName("script")[0];

    g.async = true;
    g.src = u + "matomo.js";
    s.parentNode.insertBefore(g, s);
  }
};

const Root = ({ idop, isHydrated, isLoading }) => {
  const history = useHistory();
  const location = useLocation();

  // initial load tracking
  useEffect(() => track(location.pathname, idop), [idop, location]);
  // subsequent tracking
  history.listen((l) => track(l.pathname, idop));
  return (
    <>
      <AppBar />
      {isLoading && <LinearProgress className="app-progress" />}
      {isHydrated && (
        <div id="page-container">
          <Switch>
            <Route
              path={["/:type/cs/:id", "/light/:type/cs/:id"]}
              render={({ match }) => {
                const isLight = match.path.startsWith("/light");
                const { params, url } = match;
                const props = { ...params, url, isLight };
                return <DeepLink {...props} />;
              }}
            />
            <Route exact path="/" component={Home} />
            <Route exact path="/light" component={LightHome} />
            <Route path="/ticket/callback" component={TicketCallback} />
            <ExternalRedirect from="/login" to={createTicketRequestURL} />
            <LoggedGate path="/auth/:target" />
            <Route exact path="/logout" component={Logout} />
            <LoggedRoute exact path="/admin/colors" component={Colors} />
            <Redirect to="/" />
          </Switch>
        </div>
      )}
      <Modals />
    </>
  );
};

Root.propTypes = {
  idop: PropTypes.number,
  isHydrated: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

Root.defaultProps = {
  idop: null,
};

export default Root;
